import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-finance",
  "use": "icon-finance-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-finance\"><path d=\"M730.4 241.5H293.6c-23.2 0-42-18.8-42-42s18.8-42 42-42h436.7c23.2 0 42 18.8 42 42s-18.8 42-41.9 42zM785.1 293.7H238.9c-55.4 0-100.7 45.3-100.7 100.7v371.3c0 55.4 45.3 100.7 100.7 100.7h546.3c55.4 0 100.7-45.3 100.7-100.7V394.4c0-55.4-45.4-100.7-100.8-100.7zM643.2 555.6H541.4v66.9h86.4c16.2 0 29.4 13.2 29.4 29.4s-13.2 29.4-29.4 29.4h-86.4v64.1c0 16.2-13.2 29.4-29.4 29.4s-29.4-13.2-29.4-29.4v-64.1h-86.4c-16.2 0-29.4-13.2-29.4-29.4s13.2-29.4 29.4-29.4h86.4v-66.9H380.8c-16.2 0-29.4-13.2-29.4-29.4s13.2-29.4 29.4-29.4h86.4L409.8 435c-11-11.9-10.4-30.5 1.5-41.5 11.9-11.1 30.5-10.4 41.5 1.5l59.1 63.6 59.3-63.8c11-11.9 29.6-12.6 41.5-1.5 11.9 11 12.6 29.6 1.5 41.5l-57.6 62h86.6c16.2 0 29.4 13.2 29.4 29.4s-13.1 29.4-29.4 29.4z\" p-id=\"17072\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/finance.svg
// module id = pTuU
// module chunks = 27